// scroll bar
import 'simplebar/src/simplebar.css';

import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';
import App from './App';
import { Provider as ReduxProvider } from 'react-redux';
import { store, persistor } from './redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import {NetworkStatusProvider} from "./context/Network";
import LoadingScreen from './components/LoadingScreen';

// ----------------------------------------------------------------------

    ReactDOM.render(
    <ReduxProvider store={store}>
        <PersistGate loading={<LoadingScreen />} persistor={persistor}>
            <NetworkStatusProvider>
                <App />
            </NetworkStatusProvider>
        </PersistGate>
    </ReduxProvider>,
    document.getElementById('root'));

// If you want to enable client cache, register instead.
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
